import ChartContainer from "./chart-container";

export default function DesktopContent() {
  return (
    <div className="dashboard-content">
      <ChartContainer />
    </div>
  );
}
